module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.0a433011.mp3";